import React from 'react';

const Details = () => {
    return (
        <div>
            <h1>Details</h1>
        </div>
    );
};

export default Details;